import sortIcon from "../assets/icons/sort.png";
import calendarIcon from "../assets/icons/calendar.png";
import downloadIcon from "../assets/icons/download.png";
import shareIcon from "../assets/icons/share.png";

export const APP_ICONS = {
  sort: sortIcon,
  calendar: calendarIcon,
  download: downloadIcon,
  share: shareIcon,
};
